/**
 * @generated SignedSource<<b1f8b1268f1077d0f81a0fe1fcc7f9d9>>
 * @relayHash b7d98b95b3adea74e25db9b211b46c8a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID acc77dc930afff3a478e0b3af5ffe6997c9b00162ef3c0fbb4bd22c67cf86fbf

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useIsAtlassianStaff_SnippetsCurrentUserEmailsQuery$variables = Record<PropertyKey, never>;
export type useIsAtlassianStaff_SnippetsCurrentUserEmailsQuery$data = {
  readonly user: {
    readonly emails: ReadonlyArray<{
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useIsAtlassianStaff_SnippetsCurrentUserEmailsQuery = {
  response: useIsAtlassianStaff_SnippetsCurrentUserEmailsQuery$data;
  variables: useIsAtlassianStaff_SnippetsCurrentUserEmailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "current",
    "value": true
  }
],
v1 = {
  "concreteType": "AtlassianUserEmail",
  "kind": "LinkedField",
  "name": "emails",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIsAtlassianStaff_SnippetsCurrentUserEmailsQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v0/*: any*/),
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsAtlassianStaff_SnippetsCurrentUserEmailsQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v0/*: any*/),
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
      }
    ]
  },
  "params": {
    "cacheID": "b7d98b95b3adea74e25db9b211b46c8a",
    "id": "acc77dc930afff3a478e0b3af5ffe6997c9b00162ef3c0fbb4bd22c67cf86fbf",
    "metadata": {},
    "name": "useIsAtlassianStaff_SnippetsCurrentUserEmailsQuery",
    "operationKind": "query",
    "text": "query useIsAtlassianStaff_SnippetsCurrentUserEmailsQuery{user:confluence_atlassianUser(current:true){emails{value},id}}"
  }
};
})();

(node as any).hash = "97ded5d43eeae0ead435d7bf945c6243";

export default node;
